var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8125 9.4375L31.75 10.75C32.5 10.875 33.125 11.375 33.375 12.125C33.625 12.8125 33.4375 13.625 32.875 14.125L26.375 20.5625L27.9375 29.6875C28.0625 30.4375 27.75 31.1875 27.125 31.625C26.5 32.125 25.6875 32.125 25 31.8125L17 27.5L8.9375 31.8125C8.3125 32.125 7.4375 32.125 6.875 31.625C6.25 31.1875 5.9375 30.4375 6.0625 29.6875L7.5625 20.5625L1.0625 14.125C0.5 13.625 0.3125 12.8125 0.5625 12.125C0.8125 11.375 1.4375 10.875 2.1875 10.75L11.1875 9.4375L15.1875 1.125C15.5 0.4375 16.1875 0 17 0C17.75 0 18.4375 0.4375 18.75 1.125L22.8125 9.4375Z",
    fill: "#F67924"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewStar);
export default __webpack_public_path__ + "static/media/reviewStar.57e1c5e20b48266d2314eee85a9d5aa9.svg";
export { ForwardRef as ReactComponent };